import { useEffect, useState } from "react";
import { adminToken, loadPublished, publishLab, saveDraft } from "../../data/labSync";

const pendingKeys = (draft = {}, published = {}) =>
  [...new Set([...Object.keys(draft), ...Object.keys(published)])].filter((key) => draft[key] !== published[key]);

/** Simulator only: publish the edited message texts to real accounts. */
export default function PublishPanel({ revisions, status, onStatus }) {
  const overrides = revisions.overrides || {};
  const [published, setPublished] = useState(null);
  const token = adminToken();
  useEffect(() => {
    loadPublished().then(setPublished).catch(() => setPublished({}));
  }, []);
  const pending = published ? pendingKeys(overrides, published).length : 0;
  const publish = () =>
    saveDraft(token, revisions)
      .then(() => publishLab(token))
      .then((data) => {
        onStatus(`Publié : ${data.publishedCount} texte(s) modifié(s) dans les vrais comptes.`);
        return loadPublished().then(setPublished);
      })
      .catch((problem) => onStatus(problem.message || "Publication impossible."));
  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-4" data-testid="lab-publish-panel">
      <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#189346]">Corrections des flows</div>
      {!token ? (
        <p className="mt-1 text-xs text-[#9a6b00]" data-testid="lab-publish-login">
          Vos textes restent dans ce navigateur. Connectez-vous avec un compte administrateur ou intégrateur pour les enregistrer et les publier.
        </p>
      ) : (
        <>
          <p className="mt-1 text-xs text-[#4a5f53]" data-testid="lab-sync-status">
            {status || "Vos corrections sont enregistrées sur le serveur."}
          </p>
          <p className="mt-1 text-xs font-semibold text-[#122118]" data-testid="lab-publish-pending">
            {pending ? `${pending} texte(s) pas encore dans les vrais comptes.` : "Les vrais comptes ont les derniers textes."}
          </p>
          <button
            type="button"
            onClick={publish}
            disabled={!pending}
            className="mt-2 rounded-full bg-[#122118] px-4 py-2 text-xs font-semibold text-white disabled:opacity-40"
            data-testid="lab-publish-btn"
          >
            Publier{pending ? ` (${pending})` : ""}
          </button>
        </>
      )}
    </div>
  );
}
